import { BrowserCacheLocation } from "@azure/msal-browser";

export const CLIENT_ID = "b8b7a527-73c8-411e-a7d1-d9366cf5283a"
const TENANT_ID = "3d8b34f3-cae7-4a44-8e58-d9211bd0cb47"
const BACKEND_ID = "38b871d5-1250-4572-a406-38ac7282d44d"
const API_URL = "https://api2.bservices.tech/catalogapp"
const REDIRECT_URI = "https://bcatalogo-web.bulgari.com"
const PRODUCTS_SEARCH_URL = "https://catalog-search-europe-prd.search.windows.net/indexes/products/docs";
const PRODUCTS_SEARCH_API_KEY = "62A0A5EE9AA280B3CD31F4FE2EC5723F";
const DW_BASE_URL = "https://digitalworld.bulgari.com/dam/core/asset-details?assetId=";
const MTO_URL = "https://lvmhwj.sharepoint.com/sites/Bulgari-MTO?startedResponseCatch=true";

export const environment = {
  production: false,
  local: true,
  msalConfig: {
    auth: {
      clientId: CLIENT_ID,
      authority: "https://login.microsoftonline.com/" + TENANT_ID,
      redirectUri: REDIRECT_URI,
      postLogoutRedirectUri: REDIRECT_URI,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true,
    }
  },
  backendId: BACKEND_ID,
  apiUrl: API_URL,
  productSearchBaseUrl: PRODUCTS_SEARCH_URL,
  productSearchApiKey: PRODUCTS_SEARCH_API_KEY,
  dwUrl: DW_BASE_URL,
  mtoUrl: MTO_URL,
};
